import React from 'react'

import { FormProps, FormContextType } from './Form.types'
import { FormContextProvider } from './FormContext'
import useForm from '../Inputs/useForm/useForm'

/**
 * Wrapper that provides the form context to child inputs
 */
const Form: React.FC<FormProps> = (props) => {
    const context: FormContextType = useForm(props)
    const { style, formStyle = 'default' } = props
    return (
        <FormContextProvider value={context}>
            <form style={style} className={`r-form-container r-formstyle-${formStyle}`}>
                {typeof props.children === 'function' ? props.children(context) : props.children}
            </form>
        </FormContextProvider>
    )
}

export default Form
